import PopUpHandler from './handler/view'
export {PopUpContext} from './context'
export type {PopUpContextType} from './context/index.types'

export default PopUpHandler;
